import { responseLookupServiceTypes } from '../../../services/lookup/types'
import { commentaryTopicUrl } from '../../../services/lookup/lookupServiceURL'
import useCallApi from '../../../utilities/axios'
import { getAllChecklist, deleteChecklist, orderChecklist } from '../../../services/um/umServiceURL'

export type ResponseCheckListType = {
    message: string
    status: number
    result: CheckListType[]
}

export type CheckListType = {
    checklistID: number
    nameTH: string
    nameEN: string
    irb: number
    children: SubCheckListType[]
}

export type SubCheckListType = {
    checklistID: number
    nameTH: string
    nameEN: string
}

export type RequestNewCheckList = {
    topicID: number
    parentID: number | null
    nameTH: string
    nameEN: string
    irb: number
}

export type ResponseNewCheckListType = {
    message: string
    status: number
    result: number
}

const useChecklist = () => {
    const callApi = useCallApi()

    const getAllTopic = async (irb: number) => {
        const { data } = await callApi.axiosGet<responseLookupServiceTypes.CommentaryTopicLutType>({
            url: `${commentaryTopicUrl}/${irb}`,
        })
        return data
    }

    const getCheckListByTopicID = async (topicID: number, irb: number) => {
        const { data } = await callApi.axiosGet<ResponseCheckListType>({
            url: `${getAllChecklist}/${topicID}/${irb}`,
        })

        return data.result
    }

    const addNewCheckList = async (body: RequestNewCheckList) => {
        const { data } = await callApi.axiosPost<ResponseNewCheckListType>({
            url: getAllChecklist,
            params: body,
        })

        return data
    }

    const deleteCheckList = async (topicID: number, checklistID: number, parentID: number | null) => {
        const { data } = await callApi.axiosPut<ResponseNewCheckListType>({
            url: `${deleteChecklist}/${topicID}`,
            params: {
                checklistID,
                parentID,
            },
        })

        return data
    }

    const editAllCheckList = async (
        topicID: number,
        checklistID: number,
        parentID: number | null,
        nameTH: string,
        nameEN: string,
    ) => {
        const { data } = await callApi.axiosPut<ResponseNewCheckListType>({
            url: `${getAllChecklist}/${topicID}`,
            params: {
                checklistID,
                parentID,
                nameTH,
                nameEN,
            },
        })

        return data
    }

    const reOrderChecklist = async (topicID: number, value: any) => {
        const { data } = await callApi.axiosPut<ResponseNewCheckListType>({
            url: `${orderChecklist}/${topicID}`,
            params: value.checkList,
        })

        return data
    }
    return {
        getAllTopic,
        getCheckListByTopicID,
        addNewCheckList,
        deleteCheckList,
        editAllCheckList,
        reOrderChecklist,
    }
}

export default useChecklist
